// src/config/firebase-prod-config.js

// 메인넷 환경(painori-spotnori-mainnet)을 위한 Firebase 설정
export const prodFirebaseConfig = {
  apiKey: "AIzaSyAEIkopIYa-XOBmpcUfZvgVBoTEKqJ2YLo",
  authDomain: "painori-spotnori-mainnet.firebaseapp.com",
  projectId: "painori-spotnori-mainnet",
  storageBucket: "painori-spotnori-mainnet.firebasestorage.app", // 'firebasestorage.app'이 올바른 주소입니다.
  messagingSenderId: "548716847800",
  appId: "1:548716847800:web:c435a763c33a9163e08a4d",
  // measurementId 제거됨 - Google Analytics 사용 안함
};